import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Kick off affiliate config fetch before Angular bootstraps so it runs in
// parallel with module compilation and is ready by the time FormService constructs.
const afToken = new URLSearchParams( window.location.search ).get( 'aftoken' );

const fetchAffiliateConfig = async (): Promise<any> => {

	const url = '/affiliate-config/environment-affiliates.json';

	for ( let attempt = 0; attempt < 3; attempt++ ) {

		try {

			const r = await fetch( url );
			if ( r.ok ) return await r.json();
		}
		catch {}

		if ( attempt < 2 ) await new Promise( res => setTimeout( res, 1000 ) );
	}
	return null;
};

( window as any ).__affiliateConfigPromise = afToken
	? fetchAffiliateConfig()
	: Promise.resolve( null );

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
